var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quill-editor',{ref:"editor",staticClass:"message-quill-editor",attrs:{"value":_vm.value,"options":_vm.quillConfiguration,"disabled":_vm.disabled},on:{"input":c => { this.$emit('input', c) },"ready":function($event){return _vm.onEditorReady($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }